
import defaultShapes from './default/index.js'
import dodecs from './dodecs/index.js'
import lifelike from './lifelike/index.js'
import octahedral from './octahedral/index.js'
import octahedralFast from './octahedralFast/index.js'
import octahedralRealistic from './octahedralRealistic/index.js'
import tiny from './tiny/index.js'

const shapes = {
  'default': defaultShapes,
  dodecs,
  lifelike,
  octahedral,
  octahedralFast,
  octahedralRealistic,
  tiny,
}

export default shapes
